import { render, staticRenderFns } from "./MerchandisingSchematics.vue?vue&type=template&id=6248908a&"
import script from "./MerchandisingSchematics.vue?vue&type=script&lang=js&"
export * from "./MerchandisingSchematics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports